import { createFileRoute, redirect } from "@tanstack/react-router";

/** Org-less legacy prefix; `/compliance` owns the redirect logic now. */
export const Route = createFileRoute("/regulation")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/compliance", search: location.search, replace: true });
  },
});
